module.exports = __webpack_public_path__ + "static/media/Gilroy-Medium.e16a4057.woff";